/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _header = __webpack_require__(19);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _Analytics = __webpack_require__(2);
	
	var _Analytics2 = _interopRequireDefault(_Analytics);
	
	var _Viewports = __webpack_require__(6);
	
	var _Viewports2 = _interopRequireDefault(_Viewports);
	
	var _FsLazyLoad = __webpack_require__(79);
	
	var _FsLazyLoad2 = _interopRequireDefault(_FsLazyLoad);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var analyticsMeta = document.querySelector('[fs-prop="analytics"]');
	
	if (analyticsMeta !== null && analyticsMeta.hasAttribute('utaglib-path')) {
		_Analytics2.default.sendPageView();
	}
	
	//fsLazyLoad
	var fsLazyLoad = new _FsLazyLoad2.default();
	fsLazyLoad.init();

/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ScriptLoader = __webpack_require__(3);
	
	var _ScriptLoader2 = _interopRequireDefault(_ScriptLoader);
	
	var _utils = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Analytics = function () {
	    function Analytics() {
	        _classCallCheck(this, Analytics);
	
	        if (null !== document.querySelector('[fs-prop="analytics"]')) {
	            this.init();
	        }
	    }
	
	    _createClass(Analytics, [{
	        key: 'init',
	        value: function init() {
	            this.isUtagLoaded = false;
	            this.metaObj = this.getPageMeta();
	            this.refreshRate = this.metaObj ? this.metaObj.refresh_rate : 0;
	            this.reSendMetadata();
	            this.metadataStorage = [];
	
	            //save the first article mata data
	            this.setMetadataStorage(0, this.metaObj);
	        }
	
	        /**
	         * @desc On gallery angular app, we need to update analytic meta data on every image slide onScroll.
	         *      this method is to pass the analytic meta data to /components/galleryPage/scripts/ads/adsService.js.
	         *      we call this method on pageload to set meta data for the first story. The method will be called again
	         *      on url change on 3things
	         * @param i this.metadataStorage index
	         * @param meta Meta object
	         */
	
	    }, {
	        key: 'setMetadataStorage',
	        value: function setMetadataStorage(i, meta) {
	
	            this.metadataStorage[i] = {
	                page_name: meta.page_name,
	                page_type: meta.page_type,
	                category: meta.category,
	                author: meta.author,
	                story_title: meta.story_title
	            };
	        }
	    }, {
	        key: 'getUtagLib',
	        value: function getUtagLib(url, callback) {
	
	            _ScriptLoader2.default.getScript(url, callback, true);
	        }
	    }, {
	        key: 'loadUtagLib',
	        value: function loadUtagLib(url) {
	            var _this = this;
	
	            if (!this.isUtagLoaded) {
	                this.getUtagLib(url, function () {
	                    _this.isUtagLoaded = true;
	                });
	            }
	        }
	
	        // on page load
	
	    }, {
	        key: 'sendPageView',
	        value: function sendPageView(data) {
	            //get page metadata if nothing is passed
	            var data = data || this.metaObj;
	
	            this.loadUtagLib(data.utaglib_path);
	            window.utag_data = data;
	        }
	    }, {
	        key: 'getPageMeta',
	        value: function getPageMeta() {
	            return (0, _utils.getPageMeta)();
	        }
	    }, {
	        key: 'reSendMetadata',
	        value: function reSendMetadata() {
	
	            if (this.refreshRate > 0) {
	                setInterval(function () {
	                    var data = window.utag_data;
	                    if (data !== null || data !== undefined) {
	                        this.utagView(window.utag_data);
	                    }
	                }.bind(this), this.refreshRate * 1000);
	            }
	        }
	
	        //utag api - call for any subsequent utag views
	
	    }, {
	        key: 'utagView',
	        value: function utagView(data) {
	
	            this.loadUtagLib(window.utag_data.utaglib_path);
	            /* current data format (dont remove this yet)
	            {
	             "account": "foxsports",
	             "page_name": "fscom:home:home",
	             "utags": "home|west|mlb",
	             "category": "home",
	             "page_type": "home",
	             "cms_id": "12121",
	             "page_topic": "classes:fsdigital/fscom/Home,classes:fsdigital/fscom/local/west/top-headlines,classes:fsdigital/fscom/local/west,internal:components/buzzer/mlb",
	             "filename": "http://www.foxsports.com/home",
	             "user_state": "",
	             "analyticsRefreshRate": "0"
	            }
	            */
	
	            try {
	                if (typeof utag !== 'undefined') {
	                    utag.view(data);
	                }
	            } catch (e) {
	                console.log(e);
	                throw new Error("ANALYTICS !! - something went wrong calling utag.view");
	            }
	        }
	
	        //event and link tracking
	
	    }, {
	        key: 'utagLink',
	        value: function utagLink(data) {
	            data.test = "fb-click";
	
	            try {
	                utag.link(data);
	            } catch (e) {
	                throw new Error("ANALYTICS !! - something went wrong calling utag.link");
	            }
	        }
	    }, {
	        key: 'sendEventView',
	        value: function sendEventView(data) {
	            this.utagLink(data);
	        }
	    }]);
	
	    return Analytics;
	}();
	
	exports.default = new Analytics();

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ScriptLoader = function () {
		function ScriptLoader() {
			_classCallCheck(this, ScriptLoader);
	
			this.loadedAssets = [];
		}
	
		//get browser base url
	
	
		_createClass(ScriptLoader, [{
			key: 'getBaseurl',
			value: function getBaseurl() {
				var loc = location;
				return loc.origin || loc.protocol + '//' + loc.hostname + (loc.port ? ':' + loc.port : '');
			}
	
			/**
	   * @desc check url is injected to the DOM
	   * @param url
	   * @returns {undefined or bool}
	   */
	
		}, {
			key: 'getLoadedAssets',
			value: function getLoadedAssets(url) {
				return this.loadedAssets[url];
			}
	
			/**
	   * @desc push styles or scripts into this.loadedAssets array and set its value to be boolean value
	   *       to indicate the files are loaded.
	   * @param url
	   * @param v
	   */
	
		}, {
			key: 'setLoadedAssets',
			value: function setLoadedAssets(url, v) {
				this.loadedAssets[url] = v;
			}
	
			/**
	   * inject the styles in the head
	   * @param url
	   */
	
		}, {
			key: 'getStyles',
			value: function getStyles(url) {
	
				//check if the file is loaded
				var isFileLoaded = this.getLoadedAssets(url);
	
				//if it is yes, return to the caller
				if (isFileLoaded === true) {
					return;
				}
	
				var head = document.head,
				    link = document.createElement('link');
	
				link.type = 'text/css';
				link.rel = 'stylesheet';
				link.href = url;
	
				head.appendChild(link);
	
				/**
	    * call this.setLoadedAssets to set url in this.loadedAssets
	    * to be true, indicating the file is loaded.
	    */
				this.setLoadedAssets(url, true);
			}
	
			/**
	   * @desc inject scripts into DOM dynamically with sync or async and execute a callback after script is loaded
	   * @param string url
	   * @param function callback
	   * @param bool async - true or false
	   * @return undefined
	   */
	
		}, {
			key: 'getScript',
			value: function getScript(url, callback, async) {
	
				// Create a new script and setup the basics.
				var script = document.createElement("script");
				var firstScript = document.getElementsByTagName('script')[0];
	
				//if the third argument is passed, load the script asynchronously; otherwise load it synchronously
				if (async === undefined && async !== false) {
					script.async = true;
				} else {
					script.async = false;
				}
	
				script.src = url;
				// Handle the case where an optional callback was passed in.
				if ("function" === typeof callback) {
					script.onload = function () {
	
						callback();
						// Clear it out to avoid getting called more than once or any memory leaks.
						script.onload = script.onreadystatechange = undefined;
					};
	
					script.onreadystatechange = function () {
						if ("loaded" === script.readyState || "complete" === script.readyState) {
							script.onload();
						}
					};
				}
	
				//Attach the script tag to the page (before the first script) so the magic can happen.
				firstScript.parentNode.insertBefore(script, firstScript);
			}
		}]);
	
		return ScriptLoader;
	}();
	
	exports.default = new ScriptLoader();

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getPageMeta = getPageMeta;
	/**
	 * get meta object from meta tag fs-prop="analytics" on the main article (first article on the 3things)
	 * @returns {object} Meta Object
	 */
	function getPageMeta() {
	
		var data = {};
		var metaEl = document.querySelector('[fs-prop="analytics"]');
		var attributes = ['account', 'cms-id', 'utaglib-path', 'utags', 'page-name', 'category', 'sub-category', 'page-type', 'page_topic', 'page-type-alias,', 'page-topic', 'user-state', 'filename', 'story-title', 'gallery-name', 'source', 'author', 'publish-date', 'refresh-rate', 'story-position', 'hasEmbeddedGallery', 'site-name', 'build-version', 'page-attribute', 'testScorestripPosition'];
	
		/**
	  *  to enforce html semantic, we use dashes for property names.
	  *  We need to do the dashes replacement with underscore since
	  *  analytic script uses underscore in the properties
	  */
	
		if (metaEl) {
			for (var i = 0, l = attributes.length; i < l; i++) {
				var attr = attributes[i];
				var val = metaEl.getAttribute(attr);
	
				if (val != null) {
					attr = attr.indexOf('-') >= 0 ? attr.replace(/-/g, '_') : attr;
					data[attr] = val.trim();
				}
			}
		}
	
		return data;
	}

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Viewports = function () {
	    function Viewports() {
	        var _this = this;
	
	        var viewports = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { 'mobile': 767, 'tablet': 768, 'desktop': 1024 };
	
	        _classCallCheck(this, Viewports);
	
	        var userAgent = window.navigator.userAgent;
	
	        this.winW = window.innerWidth;
	        this.winH = window.innerHeight;
	        this.docW = document.body.clientWidth;
	        this.isIOSSafari = userAgent.match(/iPhone|iPod|iPad/i) && userAgent.match(/Safari/i) && userAgent.match(/Chrome|CriOS/i) === null;
	        this.isIOS = userAgent.match(/iPhone|iPod|iPad/i);
	        this.isIphone = userAgent.match(/iPhone/i);
	        this.isAndroid = userAgent.match(/Android/i);
	        this.isIPad = userAgent.match(/iPad/i);
	        this.isMobile = userAgent.match(/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini|Windows Phone/i);
	        this.isTouch = userAgent.match(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i);
	        this.viewPorts = viewports;
	
	        window.addEventListener("resize", function () {
	            _this.setWinW(window.innerWidth);
	            _this.setWinH(window.innerHeight);
	            _this.setDocW(document.body.clientWidth);
	        });
	    }
	
	    //setter for window inner width
	
	
	    _createClass(Viewports, [{
	        key: 'setWinW',
	        value: function setWinW(w) {
	            this.winW = w;
	        }
	
	        //getter for window inner width
	
	    }, {
	        key: 'getWinW',
	        value: function getWinW() {
	            return this.winW;
	        }
	
	        //setter for document body clientWidth
	
	    }, {
	        key: 'setDocW',
	        value: function setDocW(w) {
	            this.docW = w;
	        }
	
	        //getter for document body clientWidth
	
	    }, {
	        key: 'getDocW',
	        value: function getDocW() {
	            return this.docW;
	        }
	
	        //setter for winH
	
	    }, {
	        key: 'setWinH',
	        value: function setWinH(h) {
	            this.winH = h;
	        }
	
	        //getter for winH
	
	    }, {
	        key: 'getWinH',
	        value: function getWinH() {
	            return this.winH;
	        }
	    }, {
	        key: 'getViewPort',
	        value: function getViewPort() {
	            var winW = this.winW;
	            return winW <= this.viewPorts.mobile ? 'mobile' : winW >= this.viewPorts.desktop ? 'desktop' : 'tablet';
	        }
	
	        /**
	         * @desc checking element is in view. This function works well to determine if the element is in view,
	         * but it takes a little time to do the calculation to get top, bottom, left and right positions
	         * @param object el
	         * @return bool - true or false
	         */
	
	    }, {
	        key: 'isElmInViewport',
	        value: function isElmInViewport(el) {
	
	            var rect = el.getBoundingClientRect();
	
	            return rect && rect.top >= 0 && rect.left >= 0 && rect.bottom <= this.winH && rect.right <= this.winW;
	        }
	
	        /**
	         * @desc checking element top postion is passing . This function works faster than the above isElmInViewport ,
	         * since we only need to check elment top position. This should be good to use if we just want to check the scroll
	         * position and doing pinning or lazyloading the scripts
	         * @param dom object el
	         * @param Number offet: passing an offet here if we want the scroll event rendered a bit early
	         * @return bool - true or false
	         */
	
	    }, {
	        key: 'isElmTopPosPassing',
	        value: function isElmTopPosPassing(el, offet) {
	
	            var rect = el.getBoundingClientRect();
	            var checkPos = undefined;
	
	            if (offet !== undefined && !isNaN(offet)) {
	                checkPos = rect.top - offet;
	            } else {
	                checkPos = rect.top;
	            }
	
	            return checkPos <= this.winH;
	        }
	    }]);
	
	    return Viewports;
	}();
	
	exports.default = Viewports;

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var scrollEvent = function () {
	  function scrollEvent() {
	    _classCallCheck(this, scrollEvent);
	
	    // this is working in progress scrollEvent class.
	    // We will add more scroll events in the file
	    // that can be shared across the whole site.
	
	    this.easings = {
	      linear: function linear(t) {
	        return t;
	      },
	      easeInQuad: function easeInQuad(t) {
	        return t * t;
	      },
	      easeOutQuad: function easeOutQuad(t) {
	        return t * (2 - t);
	      },
	      easeInOutQuad: function easeInOutQuad(t) {
	        return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
	      },
	      easeInCubic: function easeInCubic(t) {
	        return t * t * t;
	      },
	      easeOutCubic: function easeOutCubic(t) {
	        return --t * t * t + 1;
	      },
	      easeInOutCubic: function easeInOutCubic(t) {
	        return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
	      },
	      easeInQuart: function easeInQuart(t) {
	        return t * t * t * t;
	      },
	      easeOutQuart: function easeOutQuart(t) {
	        return 1 - --t * t * t * t;
	      },
	      easeInOutQuart: function easeInOutQuart(t) {
	        return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
	      },
	      easeInQuint: function easeInQuint(t) {
	        return t * t * t * t * t;
	      },
	      easeOutQuint: function easeOutQuint(t) {
	        return 1 + --t * t * t * t * t;
	      },
	      easeInOutQuint: function easeInOutQuint(t) {
	        return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
	      }
	    };
	  }
	
	  //throttle scrolling event to improve performance
	
	
	  _createClass(scrollEvent, [{
	    key: 'throttle',
	    value: function throttle(callback, wait) {
	      var time,
	          go = true;
	      return function () {
	        if (go) {
	          go = false;
	          time = setTimeout(function () {
	            time = null;
	            go = true;
	            callback.call();
	          }, wait);
	        }
	      };
	    }
	
	    //debounce scrolling event to improve performance
	
	  }, {
	    key: 'debounce',
	    value: function debounce(callback, delay) {
	      var timeout = null;
	      return function () {
	        if (timeout) {
	          clearTimeout(timeout);
	        }
	        var args = arguments;
	        timeout = setTimeout(function () {
	          callback.apply(null, args);
	          timeout = null;
	        }, delay);
	      };
	    }
	    // https://www.sitepoint.com/javascript-from-scratch/6/
	    // NOTE: combination of element and (current) page scroll position
	
	  }, {
	    key: 'getScrollPosition',
	    value: function getScrollPosition(el) {
	      var position = {
	        'xPos': 0,
	        'yPos': 0
	      };
	      if (el) {
	
	        var posX = 0;
	        var posY = 0;
	
	        while (el != null) {
	          posX += el.offsetLeft;
	          posY += el.offsetTop;
	          el = el.offsetParent;
	        }
	        position = {
	          'xPos': posX,
	          'yPos': posY
	        };
	      } else {
	        if (typeof window.pageYOffset != 'undefined') {
	          position = {
	            'xPos': window.pageXOffset,
	            'yPos': window.pageYOffset
	          };
	        } else if (typeof document.documentElement.scrollTop != 'undefined' && document.documentElement.scrollTop > 0) {
	          position = {
	            'xPos': document.documentElement.scrollLeft,
	            'yPos': document.documentElement.scrollTop
	          };
	        } else if (typeof document.body.scrollTop != 'undefined') {
	          position = {
	            'xPos': document.body.scrollLeft,
	            'yPos': document.body.scrollTop
	          };
	        }
	      }
	
	      return position;
	    }
	
	    /**
	     * scrolls a scrollable div to a position specified withith it.  e.g, scrollTop = 100;
	     * @param {*} container - main parent scrollable div
	     * @param {*} target - target div within parent div
	     * @param {*} duration - duration of animation
	     * @param {*} easing - easing
	     */
	
	  }, {
	    key: 'scrollTop',
	    value: function scrollTop(container, target) {
	      var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
	      var easing = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'linear';
	
	
	      var tick = 10;
	      var easings = this.easings;
	      var start = container.scrollTop;
	      var currentTime = 0;
	      var targetOffsetToScroll = target.getBoundingClientRect().top - container.getBoundingClientRect().top;
	
	      if (window.requestAnimationFrame instanceof Function === false) {
	        container.scrollTop = targetOffsetToScroll;
	        return;
	      }
	
	      var scroll = function scroll() {
	        currentTime += tick;
	        var time = Math.min(1, currentTime / duration);
	        var easingCoefficient = easings[easing](time);
	        var travelDistance = Math.ceil(easingCoefficient * targetOffsetToScroll + start);
	        container.scrollTop = travelDistance;
	
	        if (currentTime < duration) {
	          window.requestAnimationFrame(scroll);
	        }
	      };
	
	      scroll();
	    }
	    /**
	     * Use to scroll an element into view on main window
	     * @param {*} destination - element to scroll to
	     * @param {*} offset - offset to add or reduce scroll to 
	     * @param {*} duration - how long scroll will take
	     * @param {*} easing - animation type
	     * @param {*} callback - callback
	     */
	
	  }, {
	    key: 'scrollTo',
	    value: function scrollTo(destination) {
	      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	      var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
	      var easing = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'linear';
	      var callback = arguments[4];
	
	
	      var easings = this.easings;
	
	      var getCurrentTime = function getCurrentTime() {
	        return window.performance.now instanceof Function ? window.performance.now() : new Date().getTime();
	      };
	
	      var start = window.pageYOffset;
	      var startTime = getCurrentTime();
	
	      var documentHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
	      var windowHeight = window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight;
	      var destinationOffset = typeof destination === 'number' ? destination : this.getCoords(destination).top - offset;
	      var destinationOffsetToScroll = Math.round(documentHeight - destinationOffset < windowHeight ? documentHeight - windowHeight : destinationOffset);
	
	      if (window.requestAnimationFrame instanceof Function === false) {
	        window.scroll(0, destinationOffsetToScroll);
	        if (callback) {
	          callback();
	        }
	        return;
	      }
	
	      var scroll = function scroll() {
	        var now = getCurrentTime();
	        var time = Math.min(1, (now - startTime) / duration);
	        var easingCoefficient = easings[easing](time);
	        var t = Math.ceil(easingCoefficient * (destinationOffsetToScroll - start) + start);
	        window.scroll(0, t);
	
	        if (window.pageYOffset === destinationOffsetToScroll) {
	          if (callback) {
	            callback();
	          }
	          return;
	        }
	
	        requestAnimationFrame(scroll);
	      };
	
	      scroll();
	    }
	    /**
	    * returns the proper offset top on an element
	    * @return object literal with top and left
	    */
	
	  }, {
	    key: 'getCoords',
	    value: function getCoords(elem) {
	      // crossbrowser version
	      var box = elem.getBoundingClientRect();
	
	      var body = document.body;
	      var docEl = document.documentElement;
	
	      var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
	      var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
	
	      var clientTop = docEl.clientTop || body.clientTop || 0;
	      var clientLeft = docEl.clientLeft || body.clientLeft || 0;
	
	      var top = box.top + scrollTop - clientTop;
	      var left = box.left + scrollLeft - clientLeft;
	
	      return { top: Math.round(top), left: Math.round(left) };
	    }
	  }]);
	
	  return scrollEvent;
	}();
	
	;
	
	exports.default = new scrollEvent();

/***/ }),

/***/ 12:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Viewports = __webpack_require__(6);
	
	var _Viewports2 = _interopRequireDefault(_Viewports);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var screenLock = function () {
	    function screenLock() {
	        _classCallCheck(this, screenLock);
	
	        this.body = document.getElementsByTagName('body')[0];
	        this.header = document.getElementById('header-wrapper');
	        this.secondNav = document.querySelector('.section-nav');
	        this.lastYOffset = 0;
	
	        this.viewport = new _Viewports2.default({
	            'mobile': 767
	        });
	    }
	
	    _createClass(screenLock, [{
	        key: 'lockScreen',
	        value: function lockScreen() {
	            this.lastYOffset = window.pageYOffset;
	            if (!this.body.classList.contains('screen-lock')) {
	                this.body.style.top = this.lastYOffset * -1 + 'px';
	                this.body.classList.add('screen-lock');
	            }
	            this.header.classList.add('visible');
	            if (this.secondNav) this.secondNav.classList.add('fixed');
	        }
	    }, {
	        key: 'unlockScreen',
	        value: function unlockScreen() {
	            var yPos = this.body.style.top.replace(/[^-\d\.]/g, '') * -1;
	            this.body.style.top = null;
	            this.header.classList.remove('visible');
	            if (this.secondNav) this.secondNav.classList.remove('fixed');
	            this.body.classList.remove('screen-lock');
	            window.scrollTo(0, yPos);
	        }
	    }]);
	
	    return screenLock;
	}();
	
	exports.default = screenLock;

/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _navGlobal = __webpack_require__(20);
	
	var _navGlobal2 = _interopRequireDefault(_navGlobal);
	
	var _navSection = __webpack_require__(21);
	
	var _navSection2 = _interopRequireDefault(_navSection);
	
	var _navSectionSubnav = __webpack_require__(22);
	
	var _navSectionSubnav2 = _interopRequireDefault(_navSectionSubnav);
	
	var _NavSigninLoader = __webpack_require__(23);
	
	var _NavSigninLoader2 = _interopRequireDefault(_NavSigninLoader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//check if nav exists first
	var globalNav = document.getElementById("global-nav");
	if (globalNav && !globalNav.classList.contains('navigation-activated')) {
		new _navGlobal2.default();
		var navSigninLoader = new _NavSigninLoader2.default();
		navSigninLoader.init();
	
		var topLevel = document.querySelector('.section-nav .top-level');
	
		if (null !== topLevel && topLevel !== undefined) {
			new _navSection2.default();
		}
	
		var subNav = document.querySelector('.section-front-navigation');
	
		if (null !== subNav && subNav !== undefined) {
			new _navSectionSubnav2.default();
		}
	
		globalNav.classList.add('navigation-activated');
	}

/***/ }),

/***/ 20:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Handles the JavaScript associated with the Global navigation
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	
	var _scrollEvent = __webpack_require__(11);
	
	var _scrollEvent2 = _interopRequireDefault(_scrollEvent);
	
	var _Viewports = __webpack_require__(6);
	
	var _Viewports2 = _interopRequireDefault(_Viewports);
	
	var _screenLock = __webpack_require__(12);
	
	var _screenLock2 = _interopRequireDefault(_screenLock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NavGlobal = function () {
	
	    /**
	     * Intialize some variables for the Mobile Menu button and scroll positioning.
	     * Bind a scroll event listener to the window object and tie it to 'watch' function.
	     * Bind a click event listener to the mobile menu element and tie it to 'menuToggler' function.
	     *
	     * @since 0.1.0
	     */
	    function NavGlobal() {
	        _classCallCheck(this, NavGlobal);
	
	        this.mobileMenuBtn = document.getElementById('nav-open-btn');
	        this.menu = document.getElementById(this.mobileMenuBtn.dataset.target);
	        this.bodyClassList = document.body.classList;
	        this.header = document.getElementById('header-wrapper');
	        this.secondNav = document.querySelector('.section-nav');
	        this.globalNav = document.getElementById('global-nav');
	        this.globalNavWrapper = document.querySelector('.global-nav-wrapper');
	        this.globalNavContainer = document.querySelector('.global-nav-container');
	        this.globalNavOverlay = document.getElementById('global-nav-overlay');
	        this.globalNavDefault = document.querySelector('#sports-nav .menu-title');
	
	        // the inner menu selectors strings
	        var innerMenuStr = '\n            #sports-nav > li,\n            #watch-nav > li,\n            #fantasy-nav > li,\n            #more-nav > li,\n            #account-nav > li.logged-in,\n            #follow-nav > li,\n            #shows-nav > li\n        ';
	
	        this.innerMenu = document.querySelectorAll(innerMenuStr);
	        this.mActivator = document.querySelector('.m-nav-activator');
	        this.topLevel = document.querySelector('.section-nav .top-level');
	        this.navOverflow = document.querySelectorAll('.nav-overflow-more');
	        this.throttle = 'ontouchstart' in document.documentElement ? 50 : 10;
	        this.lastScrollTop = 0;
	        this.branchBannerHeight = 76;
	        this.globalNavHeight = this.globalNavContainer.offsetHeight || 68;
	        this.isGlobalNavHidden = false;
	        this.bodyTagsAdded = false;
	        this.sidebar = document.querySelector('#sidebar');
	        this.sidebarClassList = this.sidebar ? this.sidebar.classList : null;
	        this.branchBanner = document.getElementById('branch-banner-iframe');
	        this.isBannerTop = false;
	        this.screenLock = new _screenLock2.default();
	        this.viewport = new _Viewports2.default({
	            'mobile': 767,
	            'desktop': 1024
	        });
	
	        this.sportsNavContainer = document.getElementById('sports-nav-container');
	        this.sportsNavTopItems = this.sportsNavContainer ? this.sportsNavContainer.querySelectorAll('.top-level > li:not(#js-tablet-overflow)') : null;
	        this.jsTabletOverflowNav = document.getElementById('js-tablet-overflow');
	        this.sprotsNavTopSubmenu = document.querySelectorAll('#sports-nav-container .top-level > li:not(#js-tablet-overflow) > .sub-menu');
	
	        this.secondNavHeight = this.secondNav ? this.secondNav.clientHeight : 0;
	
	        this.setupScoreStrip();
	        this.initEventListeners();
	        this.adjustSportsNav();
	
	        this.isFsgo = document.querySelector('.fsg-header');
	
	        // Adding a flag to the root element so we can hook into the template with CSS
	        document.documentElement.className += " js-loaded";
	    }
	
	    _createClass(NavGlobal, [{
	        key: 'setupScoreStrip',
	        value: function setupScoreStrip() {
	            this.scoreStrip = document.querySelector('#ScorestripContainer');
	            if (this.scoreStrip) {
	                this.scoreStripHeight = this.scoreStrip.offsetHeight || 75;
	            } else {
	                document.body.classList.add('no-scorestrip');
	            }
	            this.scorestripTagsAdded = false;
	            this.scoreStripHeight = this.scoreStripHeight || 0;
	        }
	    }, {
	        key: 'initEventListeners',
	        value: function initEventListeners() {
	            var _this = this;
	
	            // Only bind the listener if the header exists.
	            if (null !== this.header) {
	                // bind "pin on scroll"
	                this.watch = this.watch.bind(this);
	                this.watch = _scrollEvent2.default.throttle(this.watch, this.throttle);
	                window.addEventListener('scroll', this.watch.bind(this));
	
	                // bind "define offset on resize"
	                this.watchResize = this.watchResize.bind(this);
	                this.watchResize = _scrollEvent2.default.throttle(this.watchResize, this.throttle);
	                window.addEventListener('resize', this.watchResize.bind(this));
	
	                // Only bind the listener if the mobile menu exists.
	                if (null !== this.mobileMenuBtn) {
	                    this.mobileMenuBtn.addEventListener('click', function () {
	                        return _this.menuToggler();
	                    });
	                }
	
	                // Only bind the listener if an inner menu exists.
	                if (this.innerMenu.length > 0) {
	                    Array.from(this.innerMenu).forEach(function (menu) {
	                        //mouse event for hover on desktop
	                        menu.addEventListener('mouseover', function (e) {
	                            return _this.innerMenuToggler(menu, e);
	                        });
	                        menu.addEventListener('mouseleave', function (e) {
	                            return _this.onMenuLeave(menu, e);
	                        });
	                        //mouse event for click on desktop, mobile and ipad
	                        menu.addEventListener('click', function (e) {
	                            return _this.innerMenuToggler(menu, e);
	                        });
	                    });
	                }
	
	                // Only bind the listener if an overflow menu links exists.
	                if (this.navOverflow.length > 0) {
	                    Array.from(this.navOverflow).forEach(function (link) {
	                        link.addEventListener('click', function (e) {
	                            return _this.navOverflowToggler(e);
	                        });
	                    });
	                }
	
	                if (this.sportsNavContainer) {
	                    this.sportsNavContainer.addEventListener('mouseover', this.onSportsNavOver);
	                }
	            }
	        }
	        /**
	         * Handle toggling classes on the body, mobile menu button and mobile menu
	         * for CSS styling and visibility when the menu is toggled on smaller screens.
	         *
	         * @since 0.1.0
	         */
	
	    }, {
	        key: 'menuToggler',
	        value: function menuToggler() {
	            /**
	             * If the mobile menu has the class 'active', remove it from the mobile menu,
	             * the mobile menu toggle and remove the body tag class 'global-menu-open'.
	             */
	            if (this.bodyClassList.contains('global-menu-open') || this.bodyClassList.contains('section-nav-open')) {
	                this.closeMenu();
	                // Otherwise, set these elements to their active classes.
	            } else {
	                this.openMenu();
	            }
	        }
	    }, {
	        key: 'closeMenu',
	        value: function closeMenu() {
	            this.globalNavContainerTopPos = this.globalNavContainer.getBoundingClientRect().top || 0;
	            if (this.viewport.getViewPort() === 'tablet' || this.bodyClassList.contains('branch-banner-is-active')) {
	                this.globalNavWrapper.style.top = null;
	            }
	            this.mobileMenuBtn.classList.remove('active');
	            this.menu.classList.remove('active');
	            this.globalNavOverlay.classList.remove('show');
	            this.globalNavWrapper.classList.remove('show');
	            this.globalNavDefault.classList.remove('active');
	            this.bodyClassList.remove('global-menu-open');
	            this.screenLock.unlockScreen();
	
	            return this;
	        }
	    }, {
	        key: 'openMenu',
	        value: function openMenu() {
	            if (this.branchBanner === null) {
	                this.branchBanner = document.getElementById('branch-banner-iframe');
	                //check if the banner is on the top.
	                if (this.branchBanner && !this.isBannerTop && this.branchBanner.style.cssText.indexOf('top') > -1) {
	                    this.isBannerTop = true;
	                }
	            }
	            //if banner is on the top, we want to scroll pass it, otherwise skip.
	            if (this.bodyClassList.contains('branch-banner-is-active') && window.pageYOffset <= this.branchBannerHeight && this.isBannerTop) {
	                window.scrollTo(0, this.branchBannerHeight);
	            }
	            this.globalNavContainerTopPos = this.globalNavContainer.getBoundingClientRect().top || 0;
	            this.mobileMenuBtn.classList.add('active');
	            this.menu.classList.add('active');
	            this.globalNavOverlay.classList.add('show');
	            this.globalNavWrapper.classList.add('show');
	            // When opening the menu, always reset to sports menu
	            Array.from(this.innerMenu).forEach(function (item) {
	                item.classList.remove('active');
	            });
	            this.globalNavDefault.classList.add('active');
	            this.bodyClassList.add('global-menu-open');
	            this.setGlobalNavWrapperHeight();
	            this.screenLock.lockScreen();
	            //close second nav if opened
	            if (this.bodyClassList.contains('section-menu-open')) {
	                this.mActivator.classList.remove('is-active');
	                this.topLevel.classList.remove('is-active');
	                this.bodyClassList.remove('section-menu-open');
	            }
	            if (this.bodyClassList.contains('scorestrip-open')) {
	                if (window.scoreStrip) window.scoreStrip.minimize();
	                this.bodyClassList.remove('scorestrip-open');
	            }
	            return this;
	        }
	        /**
	         * Handle Adding/Removing 'active' from the inner menu item
	         * effectively toggling a menu section's visibility.
	         */
	
	    }, {
	        key: 'innerMenuToggler',
	        value: function innerMenuToggler(targetMenu, e) {
	            /**
	             * handle click event toggling on primary sub menus links on ipad
	             * we need to add preventDefault on the links; otherwise, the drop down menu won't show on click/tap
	             * instead it goes to href target url, and only apply preventDefault if there is subnav, meaning there is
	             * <ul> tag next to <a> tag
	             */
	            var targetIsOverflowItem = e.target.parentElement.parentElement.parentElement.classList.contains('nav-overflow');
	            if (e.type === "click" && this.checkIfTablet() && e.target.tagName.toLowerCase() === "a" && e.target.nextSibling && !targetIsOverflowItem) {
	                e.preventDefault();
	                var targetSubMenu = e.target.parentNode.querySelector('ul.sub-menu');
	
	                Array.from(this.innerMenu).forEach(function (menu) {
	                    Array.from(menu.querySelectorAll('ul.sub-menu')).forEach(function (subMenu) {
	                        if (subMenu != targetSubMenu) {
	                            subMenu.classList.remove('ipad-hidden', 'ipad-visible');
	                        }
	                    });
	                });
	
	                this.toggleIpadMenuVisibility(targetSubMenu);
	            }
	            Array.from(this.innerMenu).forEach(function (menu) {
	                if (menu != targetMenu) menu.classList.remove('active');
	            });
	            targetMenu.classList.add('active');
	        }
	
	        /**
	         * Handle on sports nav over
	         * @param e
	         */
	
	    }, {
	        key: 'onSportsNavOver',
	        value: function onSportsNavOver(e) {
	            if (window.innerWidth < 1024) return;
	            if (!e || !e.target) return;
	
	            var target = e.target;
	            var submenu = target.tagName === 'LI' ? target.querySelector('.sub-menu') : target.parentElement.querySelector('.sub-menu');
	
	            if (!submenu || !submenu.clientWidth) return;
	
	            var rect = submenu.getBoundingClientRect();
	            var diff = document.body.clientWidth - (submenu.clientWidth + rect.left);
	            var leftStyleValue = parseInt(window.getComputedStyle(submenu, null).getPropertyValue('left'));
	
	            if (diff < 0) {
	                submenu.style.left = leftStyleValue + diff - 10 + 'px';
	            }
	        }
	
	        /**
	         * handle menu leave
	         */
	
	    }, {
	        key: 'onMenuLeave',
	        value: function onMenuLeave(targetMenu, e) {
	            var width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	            if (width >= 1024) {
	                targetMenu.classList.remove('active');
	            }
	        }
	        /**
	         * Handle visibility of overflow menu (specific for iPad landscape)
	         */
	
	    }, {
	        key: 'navOverflowToggler',
	        value: function navOverflowToggler(e) {
	            e.preventDefault();
	
	            if (this.checkIfTablet() && e.target.nextSibling) {
	                var targetSubMenu = e.target;
	                do {
	                    targetSubMenu = targetSubMenu.parentNode;
	                } while (targetSubMenu.querySelector('ul.sub-menu') == null);
	                targetSubMenu = targetSubMenu.querySelector('ul.sub-menu');
	                Array.from(this.innerMenu).forEach(function (menu) {
	                    Array.from(menu.querySelectorAll('ul.sub-menu')).forEach(function (subMenu) {
	                        if (subMenu != targetSubMenu) subMenu.classList.remove('ipad-hidden', 'ipad-visible');
	                    });
	                });
	                this.toggleIpadMenuVisibility(targetSubMenu);
	            }
	        }
	        /*
	            toggle classname for hiding/showing nav menu
	            NOTE: made for iPad/tablet viewport only
	        */
	
	    }, {
	        key: 'toggleIpadMenuVisibility',
	        value: function toggleIpadMenuVisibility(targetMenu) {
	
	            if (targetMenu.classList.contains('ipad-visible')) {
	                targetMenu.classList.remove('ipad-visible');
	                targetMenu.classList.add('ipad-hidden');
	            } else if (targetMenu.classList.contains('ipad-hidden')) {
	                targetMenu.classList.remove('ipad-hidden');
	                targetMenu.classList.add('ipad-visible');
	            } else {
	                targetMenu.classList.add('ipad-visible');
	            }
	        }
	
	        // stick - stick the navs
	
	    }, {
	        key: 'stick',
	        value: function stick() {
	            this.globalStick();
	            this.secondNavStick();
	        }
	        // unstick - unstick the navs
	
	    }, {
	        key: 'unstick',
	        value: function unstick() {
	            this.globalUnstick();
	            this.secondNavUnstick();
	        }
	    }, {
	        key: 'addAppBannerBodyTags',
	        value: function addAppBannerBodyTags() {
	            if (!this.bodyTagsAdded) {
	                this.bodyClassList.remove('appBannerDisplayed');
	                this.bodyClassList.add('appBannerHidden');
	                this.bodyTagsAdded = true;
	            }
	        }
	        // unstick for global nav
	
	    }, {
	        key: 'removeAppBannerBodyTags',
	        value: function removeAppBannerBodyTags() {
	            if (this.bodyTagsAdded && !this.bodyClassList.contains('section-menu-open')) {
	                this.bodyClassList.add('appBannerDisplayed');
	                this.bodyClassList.remove('appBannerHidden');
	                this.bodyTagsAdded = false;
	            }
	        }
	    }, {
	        key: 'hideGlobalNav',
	        value: function hideGlobalNav() {
	            if (!this.isGlobalNavHidden) {
	                //this.header.style.top = -this.globalNavHeight + 'px';
	                this.header.classList.add('push-up');
	                this.isGlobalNavHidden = true;
	            }
	        }
	    }, {
	        key: 'showGlobalNav',
	        value: function showGlobalNav() {
	            if (this.isGlobalNavHidden) {
	                this.header.classList.remove('push-up');
	                this.isGlobalNavHidden = false;
	            }
	        }
	    }, {
	        key: 'setGlobalNavWrapperHeight',
	        value: function setGlobalNavWrapperHeight() {
	            var offsetHeight = window.innerHeight - 40;
	            //checl if orientation is landscapte == 0 is portrait
	            if (window.orientation !== 0) {
	                var menuHeight = 58 * this.menu.childElementCount;
	                if (menuHeight > window.innerHeight) {
	                    offsetHeight = menuHeight;
	                }
	                this.globalNavWrapper.style.height = offsetHeight + 'px';
	            }
	
	            this.globalNavWrapper.style.height = window.innerHeight - 40 + 'px';
	        }
	    }, {
	        key: 'removeAllBodyClasses',
	        value: function removeAllBodyClasses() {
	            if (this.viewport.getViewPort() !== 'mobile') {
	                if (window.pageYOffset <= this.getYOffset()) {
	                    if (this.sidebarClassList) this.sidebarClassList.remove('fix');
	                }
	                if (this.viewport.winW >= 1024 && this.bodyClassList.contains('scorestripHidden')) {
	                    this.hideGlobalNav();
	                } else {
	                    this.showGlobalNav();
	                }
	            }
	        }
	    }, {
	        key: 'toggleSticky',
	        value: function toggleSticky(stickPoint) {
	            var scrollPos = window.pageYOffset || document.documentElement.scrollTop;
	            var scorestripPresent = this.bodyClassList.contains('scorestrip-wide');
	            if (this.bodyClassList.contains('branch-banner-is-active')) {
	                if (scrollPos > stickPoint) {
	                    this.addAppBannerBodyTags();
	                } else {
	                    this.removeAppBannerBodyTags();
	                }
	            }
	        }
	
	        // getYOffset = get Y offset
	
	    }, {
	        key: 'getYOffset',
	        value: function getYOffset() {
	            if (this.bodyClassList.contains('branch-banner-is-active')) {
	                return this.branchBannerHeight;
	            } else {
	                return 0;
	            }
	        }
	    }, {
	        key: 'checkIfTablet',
	        value: function checkIfTablet() {
	            return this.viewport.isTouch && 'desktop' === this.viewport.getViewPort();
	        }
	    }, {
	        key: 'toggleHeader',
	        value: function toggleHeader(st) {
	
	            if (this.isFsgo) return;
	
	            // Downscroll
	            if (st > this.lastScrollTop) {
	                if (st > this.secondNavHeight + this.scoreStripHeight + this.getYOffset() && !this.bodyClassList.contains('scrolled')) {
	                    this.bodyClassList.add('scrolled');
	                }
	            } else {
	                //upscroll
	                if (st < this.lastScrollTop - 1) {
	                    this.bodyClassList.remove('scrolled');
	                }
	            }
	        }
	
	        /**
	         * Watch for scrolling changes in direction.
	         *
	         * @since 0.1.0
	         */
	
	    }, {
	        key: 'watch',
	        value: function watch() {
	
	            if (this.bodyClassList.contains('global-menu-open') || document.body.classList.contains('scorestrip-open')) return;
	            var pinPos = this.getYOffset();
	
	            var st = window.pageYOffset || document.documentElement.scrollTop;
	            // Desktop
	            if (this.viewport.getViewPort() == 'desktop') {
	                // Downscroll
	                if (st > this.lastScrollTop) {
	                    if (st > pinPos) {
	                        this.addAppBannerBodyTags();
	                    }
	                    // Upscroll
	                } else {
	                    if (st < this.lastScrollTop - 1) {
	                        if (st < pinPos) {
	                            this.removeAppBannerBodyTags();
	                        }
	                    }
	                }
	            } else {
	                // Mobile/Tablet
	                this.toggleSticky(this.getYOffset());
	            }
	
	            this.toggleHeader(st);
	
	            // Update the lastScrollTop value to the page's offset.
	            this.lastScrollTop = st;
	        }
	        /**
	         * Watch for resize and orientation change.
	         */
	
	    }, {
	        key: 'watchResize',
	        value: function watchResize() {
	            this.viewport.setWinW(window.innerWidth);
	            this.globalNavHeight = this.globalNavContainer.offsetHeight;
	            if (this.globalNavWrapper.classList.contains('show') && this.viewport.winW >= 1024) {
	                this.closeMenu();
	            } else if (this.globalNavWrapper.classList.contains('show')) {
	                this.setGlobalNavWrapperHeight();
	            }
	
	            this.adjustSportsNav();
	
	            //removes body tags when resizing
	            this.removeAllBodyClasses();
	        }
	    }, {
	        key: 'adjustSportsNav',
	        value: function adjustSportsNav() {
	            if (this.viewport.winW < 1024 || this.viewport.winW > 1279) return;
	            if (!this.sportsNavContainer || !this.sportsNavTopItems) return;
	            if (this.sportsNavTopItems.length < 3 || !this.jsTabletOverflowNav) return;
	
	            var navItems = this.sportsNavContainer.querySelectorAll('.top-level > li:not(#js-tablet-overflow)');
	            var itemsWidth = [].reduce.call(navItems, function (width, i) {
	                return i.clientWidth + width;
	            }, 0);
	            var availableWidth = this.sportsNavContainer.clientWidth - itemsWidth;
	            var moreNavItemWidth = this.jsTabletOverflowNav.clientWidth + 30; // extend a bit
	
	            // if there is not enough place to fit all nav items
	            // then move two last elements of navItems into #js-tablet-overflow > .sub-menu
	            var jsTabletOverflowSubMenu = this.jsTabletOverflowNav.querySelector('.sub-menu');
	            var topLevelMenu = this.sportsNavContainer.querySelector('#sports-nav .top-level');
	
	            if (jsTabletOverflowSubMenu && topLevelMenu) {
	                var navNodesToMove = [this.sportsNavTopItems[this.sportsNavTopItems.length - 2], this.sportsNavTopItems[this.sportsNavTopItems.length - 1]];
	
	                if (!this.isNavNodesMoved && availableWidth < moreNavItemWidth) {
	                    this.movedNavNodesWidth = navNodesToMove[0].clientWidth + navNodesToMove[1].clientWidth;
	                    jsTabletOverflowSubMenu.insertBefore(navNodesToMove[1], jsTabletOverflowSubMenu.firstChild);
	                    jsTabletOverflowSubMenu.insertBefore(navNodesToMove[0], jsTabletOverflowSubMenu.firstChild);
	                    this.isNavNodesMoved = true;
	                }
	
	                if (this.isNavNodesMoved && availableWidth >= moreNavItemWidth + this.movedNavNodesWidth) {
	                    topLevelMenu.insertBefore(navNodesToMove[0], this.jsTabletOverflowNav);
	                    topLevelMenu.insertBefore(navNodesToMove[1], this.jsTabletOverflowNav);
	                    this.isNavNodesMoved = false;
	                }
	            }
	        }
	    }]);
	
	    return NavGlobal;
	}();
	
	exports.default = NavGlobal;

/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Handles the JavaScript associated with the Section navigation
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	
	var _scrollEvent = __webpack_require__(11);
	
	var _scrollEvent2 = _interopRequireDefault(_scrollEvent);
	
	var _screenLock = __webpack_require__(12);
	
	var _screenLock2 = _interopRequireDefault(_screenLock);
	
	var _Viewports = __webpack_require__(6);
	
	var _Viewports2 = _interopRequireDefault(_Viewports);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var forEach = function forEach(array, callback, scope) {
	    for (var i = 0; i < array.length; i++) {
	        callback.call(scope, i, array[i]); // passes back stuff we need
	    }
	};
	
	var NavSection = function () {
	    function NavSection() {
	        var _this = this;
	
	        _classCallCheck(this, NavSection);
	
	        this.bodyTag = document.body || document.getElementsByTagName('body')[0];
	        this.isPage = this.bodyTag.classList.contains('single-page');
	        this.isCustomPage = this.isPage && document.querySelector('link[id*=custom-style]:not([href*="/empty/"])');
	        this.subNav = document.querySelectorAll('.section-nav .top-level .sub-menu');
	        this.subNavBackHtml = '<span class="sub-menu-back">Back</span>';
	        this.moreOverflow = document.querySelector('.section-more');
	        this.sectionNav = document.querySelector('.section-nav');
	        this.throttle = 'ontouchstart' in document.documentElement ? 100 : 10;
	        this.topLevel = document.querySelector('.section-nav .top-level');
	        this.sectionNavChildCount = this.topLevel.childElementCount;
	        this.sectionNavChildren = this.topLevel.children;
	        this.mActivator = document.querySelector('.m-nav-activator');
	        this.globalNav = document.querySelector('.global-nav-container');
	        this.globalNavHeight = this.globalNav.offsetHeight;
	        this.header = document.getElementById('js-body-header');
	        this.screenLock = new _screenLock2.default();
	        this.branchBannerHeight = this.isCustomPage ? 0 : 76;
	        this.viewport = new _Viewports2.default({
	            'mobile': 767,
	            'tablet': 768,
	            'desktop': 1025
	        });
	        if (this.viewport.isIOSSafari && !this.bodyTag.classList.contains('ios-safari')) {
	            this.bodyTag.classList.add('ios-safari');
	        }
	
	        this.viewport = this.viewport.getViewPort();
	
	        // Let the CSS know we have touch available
	        if ('ontouchstart' in window || navigator.maxTouchPoints) {
	            document.documentElement.className += " has-touch";
	        } else {
	            document.documentElement.className += " no-touch";
	        }
	
	        // Set up the initial team menu state before any page-level evaluation happens
	        this.removeTeamDropdownMenu();
	
	        // Set up the watch menus
	        this.navWatchTitleLink();
	
	        /**
	         * Hides the "More" navigation item until it has been determined to be
	         * either empty or populated in order to prevent the user from seeing it
	         * in an unfinished state.
	         */
	        this.moreOverflow.style.display = 'none';
	
	        this.mActivator.addEventListener('click', function (e) {
	            return _this.mobileNavToggle(e);
	        });
	
	        // uncomment when when resume sec nav pinning
	        // bind "pin on scroll"
	        // this.navSticker = this.navSticker.bind(this);
	        // this.navSticker = scrollEvent.throttle(this.navSticker, this.throttle);
	        // window.addEventListener('scroll', this.navSticker);
	        document.addEventListener('DOMContentLoaded', function () {
	            return _this.moreMenuBuilder();
	        });
	        document.addEventListener('DOMContentLoaded', function () {
	            return _this.moveTeamDisplayMenu();
	        });
	        document.addEventListener('DOMContentLoaded', function () {
	            return _this.buildTeamSlider();
	        });
	        document.addEventListener('DOMContentLoaded', function () {
	            return _this.navMenuHandler();
	        });
	
	        window.addEventListener('resize', function () {
	            _scrollEvent2.default.debounce(100, _this.moveTeamDisplayMenu());
	        });
	
	        this.handleSubNavBack();
	    }
	
	    _createClass(NavSection, [{
	        key: 'handleSubNavBack',
	        value: function handleSubNavBack() {
	            // Add the HTML pertaining to the "Back" button on mobile sub-navigation menus.
	            var subNavBackHtml = this.subNavBackHtml;
	            forEach(this.subNav, function (index, value) {
	                var subNavLocal = value.querySelector('li:first-of-type');
	                subNavLocal.insertAdjacentHTML('beforebegin', subNavBackHtml);
	            });
	
	            // Define subNavBack after it has been inserted by the JS
	            var subNavBack = document.querySelectorAll('.section-nav .sub-menu .sub-menu-back');
	
	            // For each subNavBack, remove active class on click.
	            forEach(subNavBack, function (index, value) {
	                var subNavBackParent = value.parentNode.parentNode;
	                value.addEventListener('click', function () {
	                    if (subNavBackParent.classList.contains('is-active')) {
	                        subNavBackParent.classList.remove('is-active');
	                    }
	                });
	            });
	        }
	
	        /**
	         * Function to handle second nav dropdowns
	         */
	
	    }, {
	        key: 'navMenuHandler',
	        value: function navMenuHandler() {
	            //get nav parents when more menu is build
	            var subNavParents = document.querySelectorAll('.section-nav ul > ul > li.menu-item-has-children > a');
	            var viewport = this.viewport;
	            forEach(subNavParents, function (index, value) {
	                var subNavAnchor = value;
	                var subNavLi = value.parentNode;
	                /**
	                 * Detect wether the sub navigation should be opened on hover or click
	                 * depending on screen size.
	                 */
	                function hoverDetector() {
	                    if ('desktop' === viewport) {
	                        subNavLi.classList.add('hover');
	                    } else {
	                        subNavLi.classList.remove('hover');
	                        subNavAnchor.addEventListener('click', function (e) {
	                            return activeListener(e);
	                        });
	                    }
	                }
	
	                /**
	                 * Function to handle when the sub-navigation should appear on click.
	                 */
	                function activeListener(e) {
	                    e.preventDefault();
	                    if ("More" !== e.target.innerText && 'mobile' !== viewport) {
	                        window.open(e.target.href, "_self");
	                    }
	                    var subNavParentsActive = document.querySelectorAll('.section-nav ul > ul > li.menu-item-has-children.is-active');
	                    if (subNavLi.classList.contains('is-active') && !subNavLi.classList.contains('hover')) {
	                        subNavLi.classList.remove('is-active');
	                    } else if (subNavLi.classList.contains('is-active') && subNavLi.classList.contains('hover')) {
	                        subNavLi.classList.remove('is-active');
	                        subNavLi.classList.remove('hover');
	                    } else {
	                        forEach(subNavParentsActive, function (index, value) {
	                            value.classList.remove('is-active');
	                        });
	                        subNavLi.classList.add('is-active');
	                    }
	                }
	                hoverDetector();
	            });
	        }
	
	        /**
	         * Function to toggle classes for the mobile navigation.
	         */
	
	    }, {
	        key: 'mobileNavToggle',
	        value: function mobileNavToggle(e) {
	            e.preventDefault();
	            this.mActivator.classList.toggle('is-active');
	            this.topLevel.classList.toggle('is-active');
	            document.body.classList.toggle('section-menu-open');
	            if (document.body.classList.contains('section-menu-open')) {
	                if (document.body.classList.contains('branch-banner-is-active') && window.pageYOffset <= this.branchBannerHeight) {
	                    window.scrollTo(0, this.branchBannerHeight);
	                }
	                this.screenLock.lockScreen();
	            } else {
	                this.screenLock.unlockScreen();
	            }
	        }
	        // uncomment when when resume sec nav pinning
	        // /**
	        //  * Stick the section navigation to the top as the user scrolls down.
	        //  * Accounts for logged in users as well as logged out.
	        //  */
	        // navSticker() {
	        // 	var scrollTimeout;
	        // 	// ignore scroll events as long as an actualResizeHandler execution is in the queue
	        // 	if (!scrollTimeout) {
	        // 		scrollTimeout = setTimeout(function() {
	        // 			scrollTimeout = null;
	
	        // 			var wpAdmin = document.getElementById('wpadminbar');
	        // 			this.sectionNav = document.querySelector('.section-nav'),
	        // 				this.globalNav = document.querySelector('.global-nav-container'),
	        // 				this.globalNavHeight = this.globalNav.offsetHeight;
	
	        // 			if (null !== wpAdmin) {
	        // 				var wpAdminHeight = wpAdmin.offsetHeight;
	        // 			}
	
	        // 			if (this.globalNavHeight <= window.pageYOffset && wpAdmin === null) {
	        // 				this.sectionNav.classList.add('fixed');
	        // 				if (null !== wpAdmin) {
	        // 					this.sectionNav.style.top = wpAdminHeight + 'px';
	        // 				} else {
	        // 					this.sectionNav.style.top = '0';
	        // 				}
	        // 			} else if (this.globalNavHeight + wpAdminHeight <= window.pageYOffset + wpAdminHeight) {
	        // 				this.sectionNav.classList.add('fixed');
	        // 				if (null !== wpAdmin) {
	        // 					this.sectionNav.style.top = wpAdminHeight + 'px';
	        // 				} else {
	        // 					this.sectionNav.style.top = '0';
	        // 				}
	        // 			} else {
	        // 				this.sectionNav.classList.remove('fixed');
	        // 				this.sectionNav.style.top = null;
	        // 			}
	        // 			// The actualResizeHandler will execute at a rate of 15fps
	        // 		}, 66);
	        // 	}
	        // }
	
	        /**
	         * Build the more navigation based on space available in the top menu
	         */
	
	    }, {
	        key: 'moreMenuBuilder',
	        value: function moreMenuBuilder() {
	            var sectionNavMore = document.querySelector(' .section-more ');
	            var sectionNavMoreSub = document.querySelector('.section-more .sub-menu');
	            var menu = document.querySelector('.section-nav-wrap .menu');
	            var topMenu = menu.querySelector('.top-level');
	            var self = this;
	
	            this.buildMoreMenu(menu, sectionNavMore, sectionNavMoreSub);
	
	            // add scroll buttons to teams menu
	            this.addClickScrollToTeamsMenu();
	
	            window.addEventListener('resize', function () {
	                _scrollEvent2.default.debounce(100, self.resetAndBuild(menu, topMenu, sectionNavMore, sectionNavMoreSub));
	
	                // add scroll buttons to teams menu
	                _scrollEvent2.default.debounce(100, self.addClickScrollToTeamsMenu);
	            });
	        }
	    }, {
	        key: 'resetAndBuild',
	        value: function resetAndBuild(menu, topMenu, moreLink, moreMenu) {
	            // Reset more menu and recount items that fit in the menu
	            this.resetMoreMenu(moreLink, topMenu, menu);
	            this.buildMoreMenu(menu, moreLink, moreMenu);
	        }
	
	        /**
	         * Helper method to add multiple attribute to an element at once
	         */
	
	    }, {
	        key: 'setAttributes',
	        value: function setAttributes(el, attrs) {
	            for (var key in attrs) {
	                el.setAttribute(key, attrs[key]);
	            }
	        }
	
	        /**
	         * Clone the "Tune In" menu item for The Herd and stick it above the content area on small screen
	         */
	
	    }, {
	        key: 'cloneTuneInMenu',
	        value: function cloneTuneInMenu(menuTuneIn) {
	
	            var menuTuneInContent = menuTuneIn.innerHTML;
	            var bodyContent = document.querySelector('.body-content');
	            var bannerAdContainer = document.querySelector('.banner-ad-container');
	            var holderParentElement;
	
	            // if bodyContent and bannerAdContainer are not on the page, fail silently
	            if (!bodyContent && !bannerAdContainer) {
	                return;
	            }
	
	            // if bodyContent exists, but bannerAdContainer doesn't, move forward with bodyContent
	            if (bodyContent && !bannerAdContainer) {
	                holderParentElement = bodyContent.parentNode;
	            }
	
	            var viewports = new _Viewports2.default();
	
	            // Create a target element to move .menu-tune-in contents on small screen
	            var cloneTarget = document.createElement('div');
	            var cloneCatcher = document.createElement('div');
	
	            // Setting up this area to revieve content for viewing and assitive technology
	            this.setAttributes(cloneTarget, {
	                'class': 'menu-tune-in__clone',
	                'id': 'menu-tune-in__clone',
	                'aria-live': 'polite',
	                'aria-atomic': 'true',
	                'aria-relvent': 'additions removals'
	            });
	
	            // Create an area to catch the content
	            this.setAttributes(cloneCatcher, {
	                'class': 'menu-tune-in',
	                'id': 'menu-tune-in__catcher'
	            });
	
	            // Combine the two elements
	            cloneTarget.appendChild(cloneCatcher);
	
	            // making sure this only runs once
	            if (!document.getElementById('menu-tune-in__clone')) {
	
	                // if bannerAdContainer exists, use it, otherwise check for bodyContent
	                if (bannerAdContainer) {
	                    bannerAdContainer.parentNode.insertBefore(cloneTarget, bannerAdContainer.nextSibling);
	                } else if (bodyContent) {
	                    holderParentElement.insertBefore(cloneTarget, bodyContent);
	                }
	            } // check for clone in the DOM
	
	            // Add the cloned content into the catcher if on small screen
	            if ('mobile' === viewports.getViewPort(this.winW)) {
	
	                // Hide the menu LI from view and assitive technology
	                menuTuneIn.style.display = 'none';
	                menuTuneIn.setAttribute('aria-hidden', 'true');
	
	                // Add the new item into the DOM
	                document.getElementById('menu-tune-in__clone').setAttribute('aria-hidden', 'false');
	                document.getElementById('menu-tune-in__catcher').innerHTML = menuTuneInContent;
	            } else {
	
	                // Show the original menu item LI
	                menuTuneIn.removeAttribute('style');
	                menuTuneIn.setAttribute('aria-hidden', 'false');
	
	                // Remove this item from the DOM
	                document.getElementById('menu-tune-in__clone').setAttribute('aria-hidden', 'true');
	                document.getElementById('menu-tune-in__catcher').innerHTML = '';
	            }
	        } // this.cloneTuneInMenu();
	
	    }, {
	        key: 'buildMoreMenu',
	        value: function buildMoreMenu(menu, moreLink, moreMenu) {
	            var wrapper = document.querySelector('.section-nav-wrap');
	            var isworldcupnav = wrapper.parentElement.classList.contains('soccer-world-cup-nav');
	            var menuTuneIn = document.querySelector('.menu-tune-in');
	            var menuTopLevelItems = menu.querySelectorAll('.top-level > li.menu-item');
	            var menuTitle = menu.querySelector('.menu-title');
	            var menuTopLevelItemsCount = menuTopLevelItems.length - 1; // Remove the placeholder More top level item
	
	            var fragment = document.createDocumentFragment();
	
	            var viewports = new _Viewports2.default();
	            var menuTitleWidth = menuTitle.offsetWidth;
	
	            // The title is full width on a different line in those menus
	            if (menu.parentNode.parentNode.classList.contains('team-nav') || menu.parentNode.parentNode.classList.contains('watch-nav')) {
	                menuTitleWidth = 0;
	            }
	            var wrapperStyles = getComputedStyle(wrapper);
	            var wrapperWidth = parseInt(wrapperStyles.width, 10) - parseInt(wrapperStyles.paddingLeft, 10) - parseInt(wrapperStyles.paddingRight, 10) - menuTitleWidth;
	            var moreOffset = 'desktop' === viewports.getViewPort(this.winW) ? 175 : 300;
	            var menuWidth = parseInt(wrapperWidth - moreOffset, 10); // Allow us a 300px gap to fit eventual More link
	            var moreSubItems = 0;
	            var tempWidth = 0;
	            var breakIndex = 0;
	            var i = 0;
	
	            //clone tune in below the content if available only on mobile
	            if (menuTuneIn && 'mobile' === this.viewport) {
	
	                menuWidth = menuWidth - menuTuneIn.offsetWidth;
	
	                if (!isworldcupnav) this.cloneTuneInMenu(menuTuneIn);
	            }
	
	            // Loop through menu top level items and add up their width
	            // Stop while the added widths are smaller than the available space
	            do {
	                breakIndex = i;
	                tempWidth += menuTopLevelItems[i].offsetWidth;
	                i++;
	            } while (tempWidth < menuWidth && i <= menuTopLevelItemsCount);
	
	            // On small screens, we want exactly 10 links, counting More link
	            if ('mobile' === viewports.getViewPort(this.winW)) {
	                breakIndex = 9;
	            }
	
	            // Count how many submenu items we are left with
	            moreSubItems = menuTopLevelItemsCount - breakIndex;
	
	            // Move items that don't fit in the More submenu if there is more than one
	            // Display more link
	            if (breakIndex < menuTopLevelItemsCount && moreSubItems > 1) {
	
	                for (var j = breakIndex; j < menuTopLevelItemsCount; j++) {
	
	                    moreMenu.appendChild(menuTopLevelItems[j]);
	                } // for
	
	                // remove the style attribute instead of setting the inline CSS
	                moreLink.removeAttribute('style');
	            } // if
	
	            // Menu checks done, add class loaded
	            menu.classList.add('loaded');
	        } // buildMoreMenu()
	
	    }, {
	        key: 'resetMoreMenu',
	        value: function resetMoreMenu(moreMenu, topMenu, menu) {
	
	            var menuTuneIn = document.querySelector('.menu-tune-in');
	            var moreSubMenu = moreMenu.querySelector('.sub-menu');
	            var moreMenuItems = moreSubMenu.childNodes;
	
	            // If the moreMenuItems container doesn't exist, bail out
	            if (!moreMenuItems) {
	                return;
	            }
	
	            var moreMenuItemsCount = moreMenuItems.length;
	            var separatorItem = moreMenu;
	            var i;
	
	            // If menu tune in is present, insert items before the tune in <li>
	            if (menuTuneIn) {
	                separatorItem = menuTuneIn;
	            }
	
	            // For each item in More submenu, add it back to the top menu
	            if (moreMenuItemsCount >= 0) {
	                for (i = 0; i < moreMenuItemsCount; i++) {
	
	                    // I need this because there's a SPAN in the UL that needs to stay there
	                    if (moreMenuItems[i] && moreMenuItems[i].nodeName === 'LI' && moreMenuItems[i].innerHTML !== '') {
	                        topMenu.insertBefore(moreMenuItems[i], separatorItem);
	                    }
	                }
	            }
	
	            // Hide the more link
	            moreMenu.style.display = 'none';
	
	            // Failsafe check to see if there are any items in the menu, if so, show it.
	            if (moreMenu.querySelectorAll('.menu-item').length !== 0) {
	                moreMenu.removeAttribute('style');
	            }
	
	            // Restore menu class
	            menu.classList.remove('loaded');
	        } // resetMoreMenu()
	
	        /**
	         * Move team display menu in small screen
	         */
	
	    }, {
	        key: 'moveTeamDisplayMenu',
	        value: function moveTeamDisplayMenu() {
	            var teamDisplayMenu = document.querySelector('.local-team-display--wrapper');
	            var viewports = new _Viewports2.default();
	
	            // if the teamDisplayMenu doesn't exist, don't bother
	            if (!teamDisplayMenu) {
	                return;
	            }
	
	            if ('mobile' === viewports.getViewPort()) {
	                // Move team display menu to top of top-level menu on small screen
	                if (!this.topLevel.querySelector('.local-team-display--wrapper')) {
	                    this.topLevel.insertBefore(teamDisplayMenu, this.topLevel.firstChild);
	                }
	            } else {
	                document.querySelector('.section-nav-wrap > ul').appendChild(teamDisplayMenu);
	            }
	        }
	
	        /**
	         * Get the total width of an object
	         */
	
	    }, {
	        key: 'getTotalWidth',
	        value: function getTotalWidth(obj) {
	
	            if (!obj) {
	                return;
	            }
	
	            var style = obj.currentStyle || window.getComputedStyle(obj);
	            var objWidth = obj.offsetWidth; // includes padding
	            var objMargin = parseFloat(style.marginLeft) + parseFloat(style.marginRight);
	            var objBorder = parseFloat(style.borderLeftWidth) + parseFloat(style.borderRightWidth);
	            var totalObjWidth = objWidth + objMargin + objBorder;
	
	            return totalObjWidth;
	        }
	
	        /**
	         * Add click scrolling to team menu
	         */
	
	    }, {
	        key: 'addClickScrollToTeamsMenu',
	        value: function addClickScrollToTeamsMenu() {
	
	            // Setting and caching some variables
	            var teamMenuWrapper = document.querySelector('.local-team-display--wrapper');
	
	            // if the teamMenuWrapper isn't there, bail out
	            if (!teamMenuWrapper) {
	                return;
	            }
	
	            var teamMenu = document.querySelector('.local-team-display');
	            var teamMenuWidth = this.getTotalWidth(teamMenu);
	            var teamMenuItems = teamMenu.querySelectorAll('.menu-item');
	            var teamMenuItemCount = teamMenuItems.length;
	            var teamMenuTotalWidth = 0;
	            var i;
	            var obj;
	            var objWidthCalc;
	
	            // Loop through all the menu items to calculate the width needed to display without a scrollbar
	            for (i = 0; i < teamMenuItemCount; i = i + 1) {
	                obj = teamMenuItems[i];
	                objWidthCalc = this.getTotalWidth(obj);
	
	                // Get the total width of the menu
	                teamMenuTotalWidth = teamMenuTotalWidth + objWidthCalc;
	            }
	
	            // Check to make sure the content area is scrollable
	            if (teamMenuTotalWidth >= teamMenuWidth) {
	                teamMenuWrapper.classList.add('has-overflow');
	            } else {
	                teamMenuWrapper.classList.remove('has-overflow');
	            }
	        }
	
	        /**
	         * Build out the team slider menu, if it exists
	         */
	
	    }, {
	        key: 'buildTeamSlider',
	        value: function buildTeamSlider() {
	
	            var teamMenuWrapper = document.querySelector('.local-team-display--wrapper');
	            var teamMenu = document.querySelector('.local-team-display');
	
	            // If there's no teamMenuWrapper, bail out
	            if (!teamMenuWrapper) {
	                return;
	            }
	
	            // Prep the UI for scroll buttons
	            var prev = document.createElement('button');
	            var next = document.createElement('button');
	
	            // Add a body class to help with the extra height
	            document.body.classList.add('contains-team-display-menu');
	
	            // Build out the previous button
	            prev.setAttribute('type', 'button');
	            prev.setAttribute('aria-hidden', 'true'); // a screen reader can read the list items with out the control
	            prev.setAttribute('class', 'btn-prev');
	            prev.setAttribute('id', 'btn-prev');
	            prev.innerHTML = 'Previous';
	
	            // Build out the next button
	            next.setAttribute('type', 'button');
	            next.setAttribute('aria-hidden', 'true'); // a screen reader can read the list items with out the control
	            next.setAttribute('class', 'btn-next');
	            next.setAttribute('id', 'btn-next');
	            next.innerHTML = 'Next';
	
	            // The next button into the UI (once)
	            if (!document.getElementById('btn-next')) {
	                teamMenuWrapper.appendChild(next);
	            }
	
	            // Add the previous button into the UI (once)
	            if (!document.getElementById('btn-prev')) {
	                teamMenuWrapper.insertBefore(prev, teamMenuWrapper.firstChild);
	            }
	
	            // Event binding for "previous/scroll" button
	            document.getElementById('btn-prev').addEventListener('click', function () {
	
	                // scroll the div
	                teamMenu.scrollLeft = 0; // scroll to 0 position
	
	                // Let the CSS know what's going on
	                teamMenuWrapper.classList.add('scrolled-to-the-left');
	                teamMenuWrapper.classList.remove('scrolled-to-the-right');
	            });
	
	            // Event binding for "next/scroll" button
	            document.getElementById('btn-next').addEventListener('click', function () {
	
	                // scroll the div
	                teamMenu.scrollLeft = 1000; // scroll to the end
	
	                // Let the CSS know what's going on
	                teamMenuWrapper.classList.add('scrolled-to-the-right');
	                teamMenuWrapper.classList.remove('scrolled-to-the-left');
	            });
	        } // buildTeamSlider()
	
	        /**
	         * Modify the team-based navigation if we can/need to
	         */
	
	    }, {
	        key: 'removeTeamDropdownMenu',
	        value: function removeTeamDropdownMenu() {
	
	            // Get the container nav container when it is telling us the team display is present
	            var teamDisplayFlag = document.querySelector('.local-nav.has-team-display');
	
	            // Cache these variable for later use
	            var teamDropdropMenu;
	            var localTeamDisplay;
	
	            // If the team display flag is in the UI, move forward
	            if (teamDisplayFlag) {
	
	                // Get the team dropdown menu by className
	                teamDropdropMenu = teamDisplayFlag.querySelector('.narrow-team');
	                localTeamDisplay = teamDisplayFlag.querySelector('.local-team-display');
	
	                // Check to make sure the larger team display exists before removing the dropdown menu
	                if (localTeamDisplay) {
	
	                    // Make sure the menu is here before I try to remove it
	                    if (teamDropdropMenu) {
	
	                        // Remove the menu item, because we're using a larger version of it elsewhere in the UI
	                        teamDropdropMenu.parentNode.removeChild(teamDropdropMenu);
	                    }
	                } else {
	
	                    // If for some reason the container is telling us the larger menu should be there, but it isn't, remove the class so the UI doesn't break
	                    teamDisplayFlag.classList.remove('has-team-display');
	                } // teamDropdropMenu && localTeamDisplay
	            } // if teamDisplayFlag
	        } // removeTeamDropdownMenu()
	
	        /**
	         * Make the navigation title of a watch template a link
	         */
	
	    }, {
	        key: 'navWatchTitleLink',
	        value: function navWatchTitleLink() {
	
	            var watchNav = document.querySelector('.watch-nav');
	
	            // If the watchNav isn't available, bail out.
	            if (!watchNav) {
	                return;
	            }
	
	            // Gather some variables to work with
	            var watchNavTitle = watchNav.querySelector('.menu-title'); // scope down to the watch navigation menu
	            var watchNavTitleSpan = watchNavTitle.querySelector('span'); // get the span inside the navTitle
	            var watchNavTitleSpanText = watchNavTitleSpan.innerHTML; // Get the span text, so we can rebuild the link later
	            var topLevelNavigation = watchNav.querySelector('.top-level'); // scope down the the toplevel nav object
	            var firstLink = topLevelNavigation.querySelectorAll('a')[0]; // get the anchor
	            var firstLinkHref = firstLink.getAttribute('href'); // get the href
	            var firstLinkTitle = firstLink.getAttribute('title'); // get the href
	            var firstLinkText = firstLink.text; // get the anchor text
	            var firstLinkTextLowercase = firstLinkText.toLowerCase(); // make the word lowercase
	            var firstLinkTextClean = firstLinkTextLowercase.replace(/ /g, ''); // remove all whitespace
	
	            // Get the menu Logo link
	            var menuLogoLink = watchNav.querySelector('.menu-logo-overlay');
	
	            // Create a new link that will be inserted into the DOM
	            var newHomeLink = document.createElement('a');
	
	            // Make sure the link is labeled as "home"
	            if (firstLinkTextClean === 'home') {
	
	                if (menuLogoLink) {
	                    // Set properties of the logo overlay
	                    menuLogoLink.setAttribute('href', firstLinkHref);
	                    menuLogoLink.setAttribute('title', firstLinkTitle);
	                }
	
	                // Build out the link
	                newHomeLink.setAttribute('href', firstLinkHref);
	
	                // Add a title attr if it exists, otherwise don't worry about it
	                if (firstLinkTitle) {
	                    newHomeLink.setAttribute('title', firstLinkTitle);
	                }
	
	                // Set the link text
	                newHomeLink.innerHTML = watchNavTitleSpanText;
	
	                // Make sure the span is in the DOM (it isn't sometimes) before adding this link into the DOM
	                if (watchNavTitleSpan) {
	
	                    // Clear out the span
	                    watchNavTitleSpan.innerHTML = '';
	
	                    // Put the new link in
	                    watchNavTitleSpan.appendChild(newHomeLink);
	                } else {
	
	                    // Clear out the heading
	                    watchNavTitle.innerHTML = '';
	
	                    // Put the new link link
	                    watchNavTitle.appendChild(newHomeLink);
	                } // if span
	            } // if "home"
	        } // navWatchTitleLink()
	
	    }]);
	
	    return NavSection;
	}();
	
	exports.default = NavSection;

/***/ }),

/***/ 22:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* This object builds out an overflow menu (when needed) for subnavigation items on section front templates
	*/
	var NavSectionSubnav = function () {
		function NavSectionSubnav() {
			_classCallCheck(this, NavSectionSubnav);
	
			// Navigation wrapper
			var sectionSubnavContainer = document.querySelector('.section-front-navigation');
	
			// if subnav doesn't exist, bail out so we don't throw an error
			if (!sectionSubnavContainer) {
				return;
			}
	
			var sectionSubnavList = sectionSubnavContainer.querySelector('.section-front-subnav');
	
			// Calculated witdhs
			var menuSpaceNeeded = this.getMenuSpaceNeeded(sectionSubnavContainer);
			var menuSpaceAvailable = this.getMenuAvailableSpace(sectionSubnavContainer);
	
			// Nav items
			var sectionNavItems = document.querySelectorAll('.section-front-navigation .section-front-subnav > .menu-item');
			var sectionNavItemsCount = sectionNavItems.length;
	
			// Caching variables
			var obj;
			var j;
	
			// Building out the "More" container for overflow items
			var moreMenuBucket = this.createMoreBucket();
	
			// Put it at the end of the line
			sectionSubnavList.appendChild(moreMenuBucket);
	
			// If the space needed is more than the available space in the UI, we need to build the overflow menu out
			if (menuSpaceNeeded >= menuSpaceAvailable) {
	
				// Show the menu
				this.showElement(document.getElementById('bucket-more-parent'), 'inline-block');
	
				// Loop though all the menu items and when we hit the max width, put them in the overflow
				if (sectionNavItemsCount) {
	
					for (j = 0; j < sectionNavItemsCount; j = j + 1) {
	
						obj = sectionNavItems[j];
	
						// move flagged objects into the overflow container
						if (obj.classList.contains('add-to-overflow')) {
	
							this.addToMoreBucket(obj);
						}
					} // for
				} // if
			} else {
	
				// Hide the menu ( just in case it's showing )
				this.hideElement(document.getElementById('bucket-more-parent'), 'none');
			} // if space is needed
	
			// Events
			// The sub-menu will open on :focus in the CSS, so we don't need extra JS for that, but it's a dead link (#!) so we're just preventing it from firing
			document.getElementById('bucket-more-link').addEventListener('click', function (e) {
				e.preventDefault();
			});
		} // constructor
	
		/**
	 * Hide an element
	 */
	
	
		_createClass(NavSectionSubnav, [{
			key: 'hideElement',
			value: function hideElement(el, displayProperty) {
				el.style.display = displayProperty;
				el.setAttribute('aria-hidden', 'true');
			}
	
			/**
	  * Show an element
	  */
	
		}, {
			key: 'showElement',
			value: function showElement(el, displayProperty) {
				el.style.display = displayProperty;
				el.setAttribute('aria-hidden', 'false');
			}
	
			/**
	  * Add an item into the "more" bucket
	  */
	
		}, {
			key: 'addToMoreBucket',
			value: function addToMoreBucket(el) {
	
				document.getElementById('bucket-more-menu').appendChild(el);
			} // addToMoreBucket()
	
			/**
	  * Create "More" menu item so it can be added to the UI
	  */
	
		}, {
			key: 'createMoreBucket',
			value: function createMoreBucket() {
	
				// Building out the "More" container for overflow items
				var moreMenuBucket = document.createElement('li');
	
				// Set standard WP classes & an ID on the link bucket
				moreMenuBucket.setAttribute('class', 'menu-item menu-item-has-children');
				moreMenuBucket.setAttribute('id', 'bucket-more-parent');
	
				// Hide it by default, because we may not need it yet
				moreMenuBucket.setAttribute('aria-hidden', 'true');
				moreMenuBucket.style.display = 'none';
	
				// Build out the subNav catcher
				var moreMenuCatcher = document.createElement('ul');
				moreMenuCatcher.setAttribute('class', 'sub-menu');
				moreMenuCatcher.setAttribute('id', 'bucket-more-menu');
	
				// Budiling out the link trigger inside the "More" container
				var moreMenuLink = document.createElement('a');
				var moreMenuLinkContent = document.createTextNode('More');
				moreMenuLink.setAttribute('id', 'bucket-more-link');
	
				moreMenuLink.setAttribute('href', '#!');
				moreMenuLink.setAttribute('role', 'button');
	
				// Add content to the link
				moreMenuLink.appendChild(moreMenuLinkContent);
	
				// Putting the link and catcher inside their container
				moreMenuBucket.appendChild(moreMenuLink);
				moreMenuBucket.appendChild(moreMenuCatcher);
	
				return moreMenuBucket;
			} // createMoreBucket()
	
			/**
	  * Return how much space the menu needs based on how many items are in it and the box model calculations
	  */
	
		}, {
			key: 'getMenuSpaceNeeded',
			value: function getMenuSpaceNeeded(nav) {
	
				// Caching and setting some variables
				var navItems = nav.querySelectorAll('.section-front-subnav > .menu-item');
				var navItemsCount = navItems.length;
				var navObjStyle;
				var navItemsSingle;
				var navItemsSingleWidth;
				var navItemsSingleMarginLeft;
				var navItemsSingleMarginRight;
				var navItemsSinglePaddingLeft;
				var navItemsSinglePaddingRight;
				var navItemsSinglePadding;
				var totalWidth;
				var navItemsTotalWidth = 150; // start it at 150 to give us some spacing on the right
				var i;
	
				// Loop through each nav item and get total the width
				if (navItemsCount) {
					for (i = 0; i < navItemsCount; i = i + 1) {
	
						navItemsSingle = navItems[i];
						navObjStyle = navItemsSingle.currentStyle || window.getComputedStyle(navItemsSingle);
						navItemsSingleWidth = navItemsSingle.offsetWidth;
						navItemsSingleMarginLeft = Number(navObjStyle.marginLeft.replace('px', ''));
						navItemsSingleMarginRight = Number(navObjStyle.marginRight.replace('px', '')); // Should be 0, but just in case it changes in the future
						navItemsSinglePaddingLeft = Number(navObjStyle.paddingLeft.replace('px', '')); // Should be 0, but just in case it changes in the future
						navItemsSinglePaddingRight = Number(navObjStyle.paddingRight.replace('px', '')); // Should be 0, but just in case it changes in the future
	
						// Add up all the widths
						totalWidth = navItemsSingleWidth + navItemsSingleMarginLeft + navItemsSingleMarginRight + navItemsSinglePaddingLeft + navItemsSinglePaddingRight;
	
						// Add this width to the overall witdh
						navItemsTotalWidth = totalWidth + navItemsTotalWidth;
	
						if (this.getMenuAvailableSpace(nav) <= navItemsTotalWidth) {
							navItemsSingle.classList.add('add-to-overflow');
						}
					} // for
				} // if
	
				return navItemsTotalWidth;
			} // getMenuItems()
	
			/**
	  * Return the amount of space in nav
	  */
	
		}, {
			key: 'getMenuAvailableSpace',
			value: function getMenuAvailableSpace(nav) {
	
				return nav.offsetWidth;
			} // getMenuItems()
	
	
		}]);
	
		return NavSectionSubnav;
	}(); // NavSectionSubnav
	
	exports.default = NavSectionSubnav;

/***/ }),

/***/ 23:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _AccountsService = __webpack_require__(24);
	
	var _AccountsService2 = _interopRequireDefault(_AccountsService);
	
	var _NavSignin = __webpack_require__(25);
	
	var _NavSignin2 = _interopRequireDefault(_NavSignin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NavSigninLoader = function () {
		function NavSigninLoader() {
			_classCallCheck(this, NavSigninLoader);
		}
	
		_createClass(NavSigninLoader, [{
			key: "start",
			value: function start(opts) {
				var navSignin = new _NavSignin2.default();
				navSignin.updatelinks();
				_AccountsService2.default.get(function (err, acct) {
					if (err) return console.error(err);
	
					navSignin.toggleUpdate(acct);
					navSignin.attach(acct);
	
					acct.onlogout(function () {
						navSignin.toggleUpdate(acct);
					});
	
					acct.onlogin(function () {
						navSignin.toggleUpdate(acct);
					});
				});
			}
		}, {
			key: "init",
			value: function init() {
				//only start the events if there is global nav; otherwise, it will cause js error
				if (document.getElementById("account-nav-container")) {
					this.start();
				} else {
					return;
				}
			}
		}]);
	
		return NavSigninLoader;
	}();
	
	exports.default = NavSigninLoader;

/***/ }),

/***/ 24:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var o = {};
	
	o.getScript = function (url, callback) {
		// Create a new script and setup the basics.
		var script = document.createElement("script"),
		    firstScript = document.getElementsByTagName('script')[0];
	
		script.async = true;
		script.src = url;
	
		// Handle the case where an optional callback was passed in.
		if ("function" === typeof callback) {
			script.onload = function () {
				callback();
	
				// Clear it out to avoid getting called more than once or any memory leaks.
				script.onload = script.onreadystatechange = undefined;
			};
			script.onreadystatechange = function () {
				if ("loaded" === script.readyState || "complete" === script.readyState) {
					script.onload();
				}
			};
		}
	
		// Attach the script tag to the page (before the first script) so the magic can happen.
		firstScript.parentNode.insertBefore(script, firstScript);
	};
	
	o.lazyload = {
		js: function js(urlarr, fn) {
			o.getScript(urlarr[0], function () {
				fn();
			});
		}
	};
	
	o.callcbarr = function (cbarr) {
		var args = [].slice.call(arguments, 1);
		return cbarr.filter(function (cb) {
			cb.apply(1, args);
		});
	};
	
	o.getwisjruncached = function (opts, fn) {
		// some pages ESI include wisRegistration scripts
		// if such is case, do not request
		if ((typeof wisRegistration === "undefined" ? "undefined" : _typeof(wisRegistration)) === 'object') {
			return fn(null, wisRegistration);
		}
	
		o.lazyload.js([opts.url], function () {
			if ((typeof wisRegistration === "undefined" ? "undefined" : _typeof(wisRegistration)) === 'object') {
				fn(null, wisRegistration);
			} else {
				fn('failed to load');
			}
		});
	};
	
	o.getwisjr = function (val, cbarr, isloading) {
		cbarr = [];
		isloading = false;
		return function (opts, fn) {
			cbarr.push(fn);
			if (isloading === false) {
				isloading = val === undefined;
				if (typeof val === 'undefined') {
					o.getwisjruncached(opts, function (err, wisjr) {
						isloading = false;
						cbarr = o.callcbarr(cbarr, err, opts, val = wisjr);
					});
				} else {
					cbarr = o.callcbarr(cbarr, null, opts, val);
				}
			}
		};
	}();
	
	o.get = function (fn) {
		o.getwisjr({
			url: 'http://www.foxsports.com/accounts/Static/Bundle/JS/WIS?v=20150828',
			wisjrfilter: function wisjrfilter(opts, wisjr) {
				var wisjrwrapper = Object.create(wisjr);
	
				wisjrwrapper.getfirstName = function () {
					var firstName = "";
					var wisFirstName = wisjr.getFirstName();
					if (null !== wisFirstName && 'undefined' !== wisFirstName) {
						firstName = wisFirstName.replace(/\+/g, " ");
					}
					return firstName;
				};
				wisjrwrapper.getfirstNameInitial = function () {
					var firstName = wisjr.getFirstName();
					var firstInitial = "";
					if (null !== firstName && 'undefined' !== firstName) {
						firstInitial = firstName.charAt(0);
					}
					return firstInitial;
				};
	
				wisjrwrapper.getlastName = function () {
					var lastName = "";
					var wisLastName = wisjr.getLastName();
					if (null !== wisLastName && 'undefined' !== wisLastName) {
						lastName = wisLastName.replace(/\+/g, " ");
					}
					return lastName;
				};
	
				wisjrwrapper.getlastNameInitial = function () {
					var lastName = wisjr.getLastName();
					var lastInitial = "";
	
					if (null !== lastName && 'undefined' !== lastName) {
						lastInitial = lastName.charAt(0);
					}
					return lastInitial;
				};
	
				wisjrwrapper.onlogin = function (fn) {
					return wisjr.registerForLoginSuccess(fn);
				};
	
				wisjrwrapper.onlogout = function (fn) {
					return wisjr.registerForLogout(fn);
				};
	
				wisjrwrapper.renderlogin = function (fn) {
					return wisjr.startLoginWidget(fn);
				};
	
				wisjrwrapper.isLoggedIn = function () {
					return wisjr.isUserLoggedIn();
				};
	
				wisjrwrapper.isLoggedOut = function () {
					return !this.isLoggedIn();
				};
	
				wisjrwrapper.logout = function () {
					return wisjr.logoutUser();
				};
	
				return wisjrwrapper;
			}
		}, function (err, opts, wisjr) {
			if (err) return fn(err);
	
			if (typeof opts.wisjrfilter === 'function') {
				wisjr = opts.wisjrfilter(opts, wisjr);
			}
	
			fn(err, window.wisjr = wisjr);
		});
	};
	var AccountsService = o;
	
	exports.default = AccountsService;

/***/ }),

/***/ 25:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NavSignin = function () {
		function NavSignin() {
			_classCallCheck(this, NavSignin);
	
			this.signinContainerId = "SigninContainer";
			this.signinFontIconId = "SigninFontIconContainer";
			this.signoutLink = "userSignOutLink";
			this.greetingContainerId = "greetingContainerId";
			this.greetingNameId = "greetingNameId";
		}
	
		_createClass(NavSignin, [{
			key: "getSigninContainerElem",
			value: function getSigninContainerElem() {
				return document.getElementById(this.signinContainerId);
			}
		}, {
			key: "getSigninFontIconElem",
			value: function getSigninFontIconElem() {
				return document.getElementById(this.signinFontIconId);
			}
		}, {
			key: "getSignoutElem",
			value: function getSignoutElem() {
				return document.getElementById(this.signoutLink);
			}
		}, {
			key: "getGreetingContainer",
			value: function getGreetingContainer() {
				return document.getElementById(this.greetingContainerId);
			}
		}, {
			key: "getGreetingNameElem",
			value: function getGreetingNameElem() {
				return document.getElementById(this.greetingNameId);
			}
		}, {
			key: "doSignin",
			value: function doSignin(acct) {
				acct.renderlogin();
			}
		}, {
			key: "doSignout",
			value: function doSignout(acct) {
				if (acct.isLoggedIn()) {
					acct.logout();
				}
			}
		}, {
			key: "toggleSignedin",
			value: function toggleSignedin() {
				var that = this,
				    signinContainerElem = that.getSigninContainerElem(),
				    signinFontIconElem = that.getSigninFontIconElem();
				if (signinContainerElem && signinFontIconElem) {
					signinFontIconElem.className = "user-icon";
					signinContainerElem.className = "signinContainer site-user-controls logged-in";
				}
			}
		}, {
			key: "toggleSignedout",
			value: function toggleSignedout() {
				var that = this,
				    signinContainerElem = that.getSigninContainerElem(),
				    signinFontIconElem = that.getSigninFontIconElem();
				if (signinContainerElem && signinFontIconElem) {
					signinFontIconElem.className = "user-icon";
					signinContainerElem.className = "signinContainer site-user-controls logged-out";
				}
			}
		}, {
			key: "toggleUpdate",
			value: function toggleUpdate(acct) {
				acct.isLoggedIn() ? this.toggleSignedin() : this.toggleSignedout();
				if (acct.isLoggedIn()) {
					if (acct.getfirstName() !== "" || acct.getlastName() !== "") {
						var name = acct.getfirstName() + " " + acct.getlastName();
						this.getGreetingContainer().innerHTML = acct.getfirstNameInitial() + acct.getlastNameInitial();
						this.getGreetingNameElem().innerHTML = name;
						this.setAccountName(name.toUpperCase());
					} else {
						var _name = "Fox Sports Fan";
						this.getGreetingContainer().innerHTML = "FS";
						this.getGreetingNameElem().innerHTML = _name;
						this.setAccountName(_name.toUpperCase());
					}
				} else {
					this.getGreetingContainer().innerHTML = 'Sign In';
					this.setAccountName('');
				}
			}
		}, {
			key: "updatelinks",
			value: function updatelinks() {
				var logoutlink = document.getElementById('FSDNavAcctLogoutLink'),
				    loginlink = document.getElementById('FSDNavAcctLoginLink'),
				    href = window.location.href;
				if (loginlink) {
					loginlink.href = '/accounts/login?fu=' + encodeURIComponent(href);
				}
			}
		}, {
			key: "buildSignedInLinks",
			value: function buildSignedInLinks(acct) {
				var that = this,
				    host = location.host,
				    userProfileEditLink = document.getElementById("userProfileEditLink"),
				    userAccountEditLink = document.getElementById("userAccountEditLink"),
				    userSignoutLink = that.getSignoutElem();
	
				userSignoutLink.addEventListener('click', function () {
					that.doSignout(acct);
				});
			}
		}, {
			key: "attach",
			value: function attach(acct) {
				var that = this,
				    signinContainerElem = that.getSigninContainerElem(),
				    signinLink = that.getSigninFontIconElem();
				if (signinContainerElem) {
					signinLink.addEventListener('click', function () {
						if (acct.isLoggedIn()) {
							return false;
						} else {
							that.doSignin(acct);
						}
					});
					that.buildSignedInLinks(acct);
				}
			}
		}, {
			key: "setAccountName",
			value: function setAccountName(value) {
				var accountName = document.getElementById('accountName');
				if (!accountName) return;
	
				accountName.innerText = value;
			}
		}]);
	
		return NavSignin;
	}();
	
	exports.default = NavSignin;

/***/ }),

/***/ 79:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by amanjure on 3/11/16 and modified by Amy Huang on 08/01/16.
	 * Works only with the new picturefill (3+) on core layout and will replace the data-srcset attribute with srcset attribute for the browser to load images
	 * How it works:
	 * 1 - Looks for all img tags with lazy-srcset attributes
	 * 2 - on viewport, replaces all lazy-srcset with srcset and triggers the view for the browser
	 * 3- de-registers the scroll and load events when
	 */
	
	var FsLazyLoad = function () {
	    function FsLazyLoad() {
	        _classCallCheck(this, FsLazyLoad);
	
	        this.handlr = undefined;
	    }
	
	    _createClass(FsLazyLoad, [{
	        key: 'loadImage',
	        value: function loadImage(el) {
	            var srcset = el.getAttribute('lazy-srcset');
	            if (el !== 'undefined') {
	                el.setAttribute('srcset', srcset);
	                el.removeAttribute("lazy-srcset");
	            }
	        }
	
	        /**
	         * this function checks if the image is in viewport and returns true false accordingly
	         * @param el element in question
	         * @returns {boolean} true if in viewport, false otherwise
	         */
	
	    }, {
	        key: 'elementInViewport',
	        value: function elementInViewport(el) {
	            var rect = el.getBoundingClientRect();
	            return rect.top >= 0 && rect.left >= 0 && rect.top <= (window.innerHeight || document.documentElement.clientHeight);
	        }
	
	        /**
	         * This function is called on every scroll and it determines if the image is in viewport and if yes, then we load the image
	         */
	
	    }, {
	        key: 'processScroll',
	        value: function processScroll() {
	            var images = this.getImages();
	            var len = images.length;
	            for (var i = 0; i < len; i++) {
	                if (this.elementInViewport(images[i])) {
	                    this.loadImage(images[i]);
	                }
	            }
	            if (images.length === 0) {
	                this.deinit();
	            }
	        }
	
	        /**
	         * Returns the images as an array set in the page
	         * @param that
	         * @returns {Array}
	         */
	
	    }, {
	        key: 'getImages',
	        value: function getImages() {
	            var qry = document.querySelectorAll('#main img[lazy-srcset], .body-content img[lazy-srcset]');
	            var images = new Array();
	            for (var i = 0, l = qry.length; i < l; i++) {
	                images.push(qry[i]);
	            }
	            return images;
	        }
	
	        /**q
	         * Init function which triggers the load of lazyLoad Script on Document Load.
	         */
	
	    }, {
	        key: 'init',
	        value: function init() {
	            var _this = this;
	
	            this.handlr = function () {
	                return _this.processScroll();
	            };
	            window.addEventListener('scroll', this.handlr, false);
	            window.addEventListener('load', this.handlr, false);
	        }
	
	        /**
	         * deInit function which removes all the listeners from the page
	         */
	
	    }, {
	        key: 'deinit',
	        value: function deinit() {
	            window.removeEventListener('scroll', this.handlr, false);
	            window.removeEventListener('load', this.handlr, false);
	        }
	    }]);
	
	    return FsLazyLoad;
	}();
	
	exports.default = FsLazyLoad;

/***/ })

/******/ });


// WEBPACK FOOTER //
// assets/dist/js/partner.min.js